// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-group .file-group-width{width:50%}@media (max-width:767px){.file-group .file-group-width{width:100%}}", ""]);
// Exports
module.exports = exports;
